import { render } from "./UILoader.vue?vue&type=template&id=6fd54bb2&scoped=true&ts=true"
import script from "./UILoader.vue?vue&type=script&lang=ts"
export * from "./UILoader.vue?vue&type=script&lang=ts"

import "./UILoader.vue?vue&type=style&index=0&id=6fd54bb2&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd54bb2"]])

export default __exports__